import React from 'react';
import {Table, Image, Space, Flex, Form, Modal, Input, message, Radio, Alert} from 'antd';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import dayjs from 'dayjs';

export default () => {
    const [dataSource, setDataSource] = React.useState([]);
    const [refuseForm] = Form.useForm();
    const [agreeForm] = Form.useForm();
    const typeMap = {
        1: '个人',
        2: '公司',
        3: '个体户'
    }
    const statusMap = {
        'PENDING': '待转账',
    }

    React.useEffect(() => {
        getCashoutList().then((res) => {
            setDataSource(res.rows);
        });
    }, [])
    const getCashoutList = async () => {
        const response = await fetch('/api/sys/cash-out/list');
        const result = await response.json();

        if (result && result.success) {
            return result.data;
        }else{
            return [];
        }
    }


    const agree = async (shopId, flowId) => {
        Modal.confirm({
            icon: null,
            title: '确任转账',
            content: 
                <div>
                    <Alert message='请对照银行转账信息填写转账信息' type='warning' style={{marginBottom: '10px'}} />
                    <Form form={agreeForm} layout='vertical'>
                        <Form.Item name='bankTitle' 
                            rules={[{ required: true, message: '请输入银行抬头' }]}
                            label='转入银行抬头'
                        >
                            <Input placeholder='请输入银行抬头' />
                        </Form.Item>
                        <Form.Item name='bankNo' 
                            rules={[{ required: true, message: '请输入银行账号' }]}
                            label='转入银行账号'
                        >
                            <Input placeholder='请输入银行账号' />
                        </Form.Item>
                        <Form.Item name='amount' 
                            rules={[{ required: true, message: '请输入转账金额' }]}
                            label='转入金额'
                        >
                            <Input placeholder='请输入转账金额' />
                        </Form.Item>
                        <Form.Item name='bankFlowId' 
                            rules={[{ required: true, message: '请输入转账流水号' }]}
                            label='转账流水号'
                        >
                            <Input placeholder='请输入转账流水号' />
                        </Form.Item>
                    </Form>
                </div>,
            onOk: async () => {
                const values = await agreeForm.validateFields();

                const response = await fetch(`/api/sys/cash-out/confirm?flowId=${flowId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ...values,
                        shopId
                    })
                });
                const result = await response.json();

                if (result && result.success) {
                    message.success('操作成功');
                    setTimeout(() => {
                        getCashoutList().then((res) => {
                            setDataSource(res.rows);
                        });
                    }, 500);
                } else {
                    message.error(result.data);
                }
            }
        })
    }

    const columns = [
        {
            title: '账户名称',
            dataIndex: 'accId',
            render: (accId, r) => {
                return <div>
                    <div>{r?.acc?.companyName || r?.acc?.realname}</div>
                    <div>{accId}</div>
                </div>
            }
        },
        {
            title: '账户类型',
            dataIndex: 'type',
            render: (text, r) => {
                return <div>
                    <div>{typeMap[r?.acc?.type]}</div>
                </div>
            }
        },
        {
            title: '提现金额',
            dataIndex: 'amount',
            render: (amount) => {
                return -(amount / 100)
            }
        },
        {
            title: '手续费',
            dataIndex: 'amount',
            render: (amount, r) => {
                const {acc = {}} = r;
                const { version } = acc;
                return (Math.round(-amount * (version.activeFee || version.fee)) / 100)
            }
        },
        {
            title: '实际转账',
            dataIndex: 'amount',
            render: (amount, r) => {
                const {acc = {}} = r;
                const { version } = acc;
                amount = (-amount - Math.round(-amount * (version.activeFee || version.fee))) / 100
                return <Flex gap={8} align='center'>
                    <span style={{ color: 'red' }}>{amount}</span>
                    <CopyToClipboard text={amount} onCopy={() => message.success('复制成功')}>
                        <a style={{ fontSize: '12px'}}>复制</a>
                    </CopyToClipboard>
                </Flex>
            }
        },
        {
            title: '银行信息',
            dataIndex: 'amount',
            render: (amount, r) => {
                const {shop = {}} = r;
                return <div>
                    <Flex gap={8} align='center'>
                        <span>账号：{shop.bankNo}</span>
                        <CopyToClipboard text={shop.bankNo} onCopy={() => message.success('复制成功')}>
                            <a style={{ fontSize: '12px'}}>复制</a>
                        </CopyToClipboard>
                    </Flex>
                    <Flex gap={8} align='center'>
                        <span>账户名：{shop.bankTitle}</span>
                        <CopyToClipboard text={shop.bankTitle} onCopy={() => message.success('复制成功')}>
                            <a style={{ fontSize: '12px'}}>复制</a>
                        </CopyToClipboard>
                    </Flex>
                    <Flex gap={8} align='center'>
                        <span>银行名称：{shop.bankName}</span>
                        <CopyToClipboard text={shop.bankName} onCopy={() => message.success('复制成功')}>
                            <a style={{ fontSize: '12px'}}>复制</a>
                        </CopyToClipboard>
                    </Flex>
                </div>
            }
        },
        {
            title: '申请时间',
            dataIndex: 'createTime',
            render: (text) => {
                return dayjs(text).format('YYYY-MM-DD HH:mm')
            }
        },
        {
            title: '操作人',
            dataIndex: 'operator',
        },
        {
            title: '操作',
            dataIndex: 'status',
            fixed: 'right',
            render: (status, r) => {
                return <Space>
                    {
                        status === 'PENDING' && <a onClick={() => agree(r.shopId, r.flowId)}>确认转账</a>
                    }
                    {
                        status === 'SUCCESS' && '已转账'
                    }
                </Space>
            }
        },
    ]
    return (
        <div>
            <h1>审核列表</h1>
            <Table size='small' rowKey={'accId'} columns={columns} dataSource={dataSource} scroll={{ x: 'max-content' }} />
        </div>
    )
}